export default [
  {
    key: 'agent_code',
    value: '',
    label: 'agentCode',
    rules: {
      requiredWithFormat: true,
      minmax: { min: 6, max: 30 },
      adminID: true,
    },
    name: 'agentCode',
    as: 'input',
  },
  {
    key: 'company',
    value: '',
    label: 'company',
    rules: { required: true, max: 30 },
    name: 'company',
    as: 'input',
  },
  {
    key: 'admin_name',
    value: '',
    label: 'administratorId',
    rules: {
      requiredWithFormat: true,
      minmax: { min: 6, max: 30 },
      adminID: true,
    },
    name: 'administratorId',
    as: 'input',
  },
  {
    key: 'email',
    value: '',
    label: 'contactMail',
    rules: { requiredWithFormat: true, email: true },
    name: 'email',
    as: 'input',
  },
  {
    key: 'phone',
    value: '',
    label: 'contactPhone',
    rules: { phone: true },
    name: 'contactPhone',
    as: 'input',
  },
  {
    key: 'management_url',
    rules: { required: false, scope: { min: 1, max: 2000 } },
    value: '',
    label: 'managementUrl',
    as: 'plaintext',
  },
  {
    key: 'created_at',
    value: '',
    label: 'createdAt',
    name: 'createdAt',
    as: 'plaintext',
  },

  {
    key: 'updated_at',
    value: '',
    label: 'updatedAt',
    name: 'updatedAt',
    as: 'plaintext',
  },
]
